import React from "react";
import { Box, Grid, Rating, Stack } from "@mui/material";
import LandingHeader from "../../../layout/header";
import Footer from "../../../layout/footer";
import { BlueBox, BtnAccess, ReviewBox } from "../style";
import { RootStyle, Text, Title } from "../style";
import { AboutGrid, AboutText, AboutTitle } from "../style";
import AboutImg from "../../../images/landing/hr module.png";
import Icon1 from "../../../images/landing/hr icon 1.png";
import Icon2 from "../../../images/landing/hr icon 2.png";
import Icon3 from "../../../images/landing/hr icon 3.png";
import PartnerLogo from "../../../images/landing/anh.png";
import { Link } from "react-router-dom";
import AccessNow from "../AccessNow";
import { InnerBlueBox } from "../style";

function HRModule() {
  return (
    <Box sx={{ background: "#fff" }}>
      <LandingHeader />
      <RootStyle sx={{ my: "40px" }}>
        <Stack spacing="64px">
          <BlueBox sx={{ minHeight: "163px" }}>
            <InnerBlueBox sx={{ p: "0 0 0 32px", maxHeight: "163px" }}>
              <Grid container>
                <AboutGrid item md={7} xs={12}>
                  <AboutTitle>HR Management System</AboutTitle>
                  <Link to="/inventory/login">
                    <BtnAccess>Access Now</BtnAccess>
                  </Link>
                </AboutGrid>
                <Grid item md={5} xs={12} sx={{ order: { xs: 1, md: 2 } }}>
                  <Box>
                    <img
                      style={{ maxHeight: "163px" }}
                      width="100%"
                      src={AboutImg}
                      alt=""
                    />
                  </Box>
                </Grid>
              </Grid>
            </InnerBlueBox>
          </BlueBox>

          <Stack spacing="40px" alignItems="center">
            <AboutTitle sx={{ color: "#60656C", textAlign: "center" }}>
              Unleash your HR potential and streamline employee management with
              our robust platform
            </AboutTitle>
            <img src={Icon1} alt="" />
          </Stack>

          <Box
            sx={{
              background: "#FFFAEC",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={8} xs={12} order={{ xs: 2, md: 1 }}>
                <AboutText>
                  HR module provides you with everything you need, including:
                </AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Simplified Registration:</b> Employees easily register
                      using your company code and password, ensuring a smooth
                      onboarding experience.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Pay Salaries with Ease:</b> Process employee salaries
                      efficiently with accurate calculations and secure online
                      payments.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Track Salary History:</b>Access detailed salary records
                      for all employees, enabling efficient payroll monitoring
                      and analysis.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Enhanced Time Tracking:</b>Timely Clock-in/Clock-out:
                      Employees track their workday accurately with intuitive
                      timekeeping features.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Detailed Time Logs:</b> Analyse employee work hours
                      with comprehensive time logs, providing valuable insights
                      into productivity and resource allocation.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Feature-Based Control:</b> Grant access to specific
                      platform features based on employee roles and
                      responsibilities.
                    </AboutText>
                  </li>
                </ul>
              </Grid>
              <Grid item md={4} xs={12} order={{ xs: 1, md: 2 }}>
                <img width="100%" src={Icon2} alt="" />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              background: "#FFFAEC",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={4} xs={12}>
                <img width="100%" src={Icon3} alt="" />
              </Grid>
              <Grid item md={8} xs={12}>
                <AboutText>Benefits:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Reduced administrative burden:</b>Automate routine HR
                      tasks, freeing up valuable time for strategic initiatives.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Improved employee experience:</b> Provide a
                      self-service portal for employees to access their
                      information and manage their time.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Enhanced data accuracy:</b> Eliminate manual data entry
                      and ensure accurate payroll calculations.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Increased transparency:</b> Gain valuable insights into
                      workforce performance and make informed decisions.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Simplified compliance:</b> Maintain compliance with
                      labor laws with comprehensive timekeeping and
                      record-keeping features.
                    </AboutText>
                  </li>
                </ul>
                <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                  The HR Management System empowers you to take control of your
                  workforce management, optimise HR processes, and create a
                  positive employee experience.
                </AboutText>
              </Grid>
            </Grid>
          </Box>

          <ReviewBox>
            <Grid container spacing="16px">
              <Grid
                item
                md={6}
                xs={12}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Stack>
                  <Text sx={{ color: "#fff" }}>
                    "One of the standout features of ManageKaro is its seamless
                    and efficient payroll management system. The platform has
                    significantly simplified the complex task of calculating and
                    processing employee salaries, saving us time and reducing
                    the margin for errors.The customization options within
                    ManageKaro have allowed us to tailor the system to meet the
                    specific needs of ANH Dropshipping. We can easily configure
                    salary structures, allowances, and deductions, ensuring that
                    the payroll system aligns seamlessly with our company
                    policies.”
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <Rating name="simple-controlled" value={5} />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={PartnerLogo} alt="" />
                  <Box>
                    <Title sx={{ color: "#fff" }}>ANH Dropshipping</Title>
                    <Title sx={{ color: "#fff", fontSize: "24px" }}>
                      Mr Faris Sheikh
                    </Title>
                    <Text sx={{ color: "#fff", fontStyle: "italic" }}>
                      Main Saddar Market, Karachi
                    </Text>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </ReviewBox>

          <AccessNow />
        </Stack>
      </RootStyle>
      <Footer />
    </Box>
  );
}

export default HRModule;
